<template>
  <div class="relative mb-2 flex w-[19.75rem] overflow-hidden rounded-lg bg-white p-4 shadow-md">
    <div
      class="absolute top-4 left-4 flex h-5 w-5 items-center justify-center rounded-full"
      :class="{
        'bg-success-100': notification.type === UiNotificationType.SUCCESS,
        'bg-error-100': notification.type === UiNotificationType.ERROR,
        'bg-warning-100': notification.type === UiNotificationType.WARNING,
        'bg-info-100': notification.type === UiNotificationType.INFO
      }"
    >
      <font-awesome-icon
        v-if="notification.type === UiNotificationType.SUCCESS"
        :icon="['fas', 'check']"
        size="sm"
        class="text-success-500"
      />

      <font-awesome-icon
        v-if="notification.type === UiNotificationType.ERROR"
        :icon="['fas', 'xmark']"
        size="1x"
        class="text-error-500"
      />

      <font-awesome-icon
        v-if="notification.type === UiNotificationType.WARNING"
        :icon="['fal', 'triangle-exclamation']"
        size="xs"
        class="text-warning-500"
      />

      <font-awesome-icon
        v-if="notification.type === UiNotificationType.INFO"
        :icon="['fas', 'info']"
        size="xs"
        class="text-info-500"
      />
    </div>

    <div class="w-full pr-8 pl-9">
      <h1 class="font-inter text-[0.75rem] font-semibold leading-[1.4375rem] text-neutral-700">
        {{ notification.title }}
      </h1>
      <p class="text-[0.625rem] leading-[0.875rem] text-neutral-400">{{ notification.message }}</p>
    </div>

    <font-awesome-icon
      :icon="['fas', 'xmark']"
      size="1x"
      class="absolute top-4 right-4 w-4 cursor-pointer text-neutral-500 hover:text-neutral-300 focus:text-neutral-700"
      @click="onClick()"
    />

    <div
      class="absolute bottom-0 left-0 h-[0.4375rem] w-full"
      :class="{
        'bg-success-100': notification.type === UiNotificationType.SUCCESS,
        'bg-error-100': notification.type === UiNotificationType.ERROR,
        'bg-warning-100': notification.type === UiNotificationType.WARNING,
        'bg-info-100': notification.type === UiNotificationType.INFO
      }"
    />

    <div
      class="absolute bottom-0 left-0 h-[0.4375rem] w-full"
      :class="{
        'bg-success-500': notification.type === UiNotificationType.SUCCESS,
        'bg-error-500': notification.type === UiNotificationType.ERROR,
        'bg-warning-500': notification.type === UiNotificationType.WARNING,
        'bg-info-500': notification.type === UiNotificationType.INFO
      }"
      :style="{ animation: `hideAnimation ${notification.timeout}ms linear 0s`, 'animation-fill-mode': 'forwards' }"
    />
  </div>
</template>

<script lang="ts" setup>
import { UiNotificationType, type UiNotification } from '@infuse/ui/domain';

const emit = defineEmits(['click']);

interface Props {
  notification: UiNotification;
}

const props = defineProps<Props>();

function onClick() {
  emit('click');
}
</script>

<style lang="scss">
@keyframes hideAnimation {
  0% {
    width: 100%;
  }
  100% {
    width: 0;
  }
}
</style>
